import { StackProps, styled, Theme } from "@mui/material";

interface IProgressCircleTrail {
  r?: string;
  strokesDash?: {
    strokeDasharray: number;
    strokeDashoffset: number;
  } | null,
  mandatory?: boolean;
  isHover?: boolean;
  theme?: Theme;
}

interface IProgressCircle extends IProgressCircleTrail {
}

export const SvgCircleContainer = styled("g")<StackProps & IProgressCircle>(({ isHover }) => ({
  ".progress-circle": {
    opacity: isHover ? 1 : 0.5
  },
  ".trail-circle": {
    opacity: isHover ? 1 : 0.5
  },
  ":hover > .progress-circle": {
    opacity: 1
  },
  ":hover > .trail-circle": {
    opacity: 1
  }

}));


export const ProgressCircleTrail = styled("circle")<StackProps & IProgressCircleTrail>(({
  theme,
  r
}) => ({
  cx: "0",
  cy: "0",
  fill: "transparent",
  opacity: 0.5,
  r: r,
  stroke: theme.customColors.border,
  strokeWidth: "0.24rem",
  transition: "all 0.1 ease-in"
}));


export const ProgressCircle = styled("circle")<StackProps & IProgressCircleTrail>(({
  theme,
  strokesDash,
  r,
  mandatory
}: IProgressCircleTrail) => ({
  cx: "0",
  cy: "0",
  fill: "transparent",
  opacity: 0.5,
  r: r,
  stroke: mandatory ? theme?.customColors.textWarning : theme?.customColors.systemSecondary01,
  strokeDasharray: strokesDash?.strokeDasharray,
  strokeDashoffset: strokesDash?.strokeDashoffset,
  strokeLinecap: "round",
  strokeWidth: "0.24rem"
}));
